import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import Avatar from '@material-ui/core/Avatar';
import params from '../../../setup/config/params';
import { URL_WEB } from '../../../setup/config/env';

const Container = styled.div`
    display: grid;
    grid-template-rows: 100px 1fr;
`;

const Header = styled.div`
    display: grid;
    grid-template-columns: .1fr .9fr;
    align-items: center;
    color: rgba(255,255,255,0.8);
    background-color: #0B315E;
`;
const HeaderImg = styled.div`
    display: grid;
    align-items: center;
    justify-items: center;
`;

const Paper = styled.section`
  padding: 3rem 3.5rem;
  border-radius: 10px;
  background-color: white;
  box-sizing: border-box;
  z-index: 10;
`;

const PrivacyPolicy = () => {
  return (
      <>
    <Helmet>
        <title>{`Privacy Policy · ${params.site.name}`}</title>
    </Helmet>
      <Container>
          <Header>
            <HeaderImg>
              <Avatar src={`${URL_WEB}/icons/gitDone.png`}></Avatar>
            </HeaderImg>
            <h1>GITDONE</h1>
          </Header>
      <Paper>
        <h1 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }}>Privacy Policy</h1>
        <p style={{ paddingBottom: '30px' }}>
        This Privacy Policy describes Our policies and procedures on the collection,
        use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
        We use Your Personal data to provide and improve the Service. By using the Service,
        You agree to the collection and use of information in accordance with this Privacy Policy.
        </p>
        <h1 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }}>Interpretation and Definitions</h1>
        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Interpretation</h2>
        <p style={{ paddingBottom: '30px' }}>
        The words of which the initial letter is capitalized have meanings defined under the following conditions.
        The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>
        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }}>Definitions</h2>
        <p style={{ paddingBottom: '10px' }}>
        For the purposes of this Privacy Policy:
        </p>
        <ul>
          <li style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>You</span> means the individual accessing or using the Service,
          or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Company </span>
          (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to ALIO IT SOLUTIONS LLC.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Application </span>
           means the software program provided by the Company downloaded by You on any electronic device, named GitDone.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Affiliate </span>
          means an entity that controls, is controlled by or is under common control with a party,
          where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors
          or other managing authority.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Account </span> means a unique account created for You to access our Service or parts of our Service.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Service </span>  refers to the Application.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Country </span> refers to:  United States of America
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Service Provider </span>
          means any natural or legal person who processes the data on behalf of the Company.
          It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company,
          to perform services related to the Service or to assist the Company in analyzing how the Service is used.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Third-party Social Media Service </span>
          refers to any website or any social network website through which a User can log in or create an account to use the Service.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Personal Data </span>is any information that relates to an identified or identifiable individual.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>Device </span>means any device that can access the Service such as a computer, a cellphone or a digital tablet.
          </li>
          <li style={{ marginBottom: '50px' }}>
          <span style={{ fontWeight: 'bold' }}>Usage Data </span>refers to data collected automatically,
          either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
          </li>
        </ul>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Collecting and Using Your Personal Data</h2>
        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Types of Data Collected</h2>
        <h3 style={{ marginBottom: '30px' }} >Personal Data</h3>
        <p style={{ paddingBottom: '20px' }}>
        While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You.
        Personally identifiable information may include, but is not limited to:
        </p>
        <ul>
          <li style={{ marginBottom: '10px' }}> Email address
          </li>
          <li style={{ marginBottom: '30px' }}>
          Usage Data
          </li>
        </ul>

        <h3 style={{ marginBottom: '30px' }} >Usage Data</h3>
        <p style={{ paddingBottom: '20px' }}>
        Usage Data is collected automatically when using the Service.
        </p>
        <p style={{ paddingBottom: '20px' }}>
        Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type,
        browser version, the pages of our Service that You visit, the time and date of Your visit,
        the time spent on those pages, unique device identifiers and other diagnostic data.
        </p>
        <p style={{ paddingBottom: '20px' }}>
        the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system,
        the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
        </p>
        <p style={{ paddingBottom: '30px' }}>
        We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }}>Use of Your Personal Data</h2>
        <p style={{ paddingBottom: '10px' }}>
        The Company may use Personal Data for the following purposes:
        </p>
        <ul>
          <li style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>To provide and maintain our Service, </span>
          including to monitor the usage of our Service.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>To manage Your Account: </span>
          to manage Your registration as a user of the Service.
          The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>For the performance of a contract: </span>
          the development, compliance and undertaking of the purchase contract for the products,
          items or services You have purchased or of any other contract with Us through the Service.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>To contact You: </span>
          To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication,
          such as a mobile application's push notifications regarding updates or informative communications related to the functionalities,
          products or contracted services, including the security updates, when necessary or reasonable for their implementation.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>To provide You </span>
          with news, special offers and general information about other goods, services and events which we offer that are similar
          to those that you have already purchased or enquired about unless You have opted not to receive such information.
          </li>
          <li style={{ marginBottom: '50px' }}>
          <span style={{ fontWeight: 'bold' }}>To manage Your requests: </span>  To attend and manage Your requests to Us.
          </li>
        </ul>

        <p style={{ paddingBottom: '10px' }}>
        We may share your personal information in the following situations:
        </p>
        <ul>
          <li style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>With Service Providers: </span>
          We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>For Business transfers: </span>
          We may share or transfer Your personal information in connection with, or during negotiations of, any merger,
          sale of Company assets, financing, or acquisition of all or a portion of our business to another company.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>With Affiliates: </span>
          We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy.
          Affiliates include Our parent company and any other subsidiaries,
          joint venture partners or other companies that We control or that are under common control with Us.
          </li>
          <li style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>With Business partners: </span>
          We may share Your information with Our business partners to offer You certain products, services or promotions.
          </li>
          <li style={{ marginBottom: '50px' }}>
          <span style={{ fontWeight: 'bold' }}>With other users:  </span>
          when You share personal information or otherwise interact in the public areas with other users,
          such information may be viewed by all users and may be publicly distributed outside.
          If You interact with other users or register through a Third-Party Social Media Service,
          Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures and description of Your activity.
          Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile.
          </li>
        </ul>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Retention of Your Personal Data</h2>
        <p style={{ paddingBottom: '10px' }}>
        The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy.
        We will retain and use Your Personal Data to the extent necessary to comply with our legal obligation
        (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time,
        except when this data is used to strengthen the security or to improve the functionality of Our Service,
        or We are legally obligated to retain this data for longer time periods.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Transfer of Your Personal Data</h2>
        <p style={{ paddingBottom: '10px' }}>
        Your information, including Personal Data, is processed at the Company's operating offices and in any other places
        where the parties involved in the processing are located.
        It means that this information may be transferred to — and maintained on — computers located outside of Your state, province,
        country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
        </p>
        <p style={{ paddingBottom: '10px' }}>
        Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy
        and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls
        in place including the security of Your data and other personal information.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Disclosure of Your Personal Data</h2>
        <h3 style={{ marginBottom: '30px' }} >Business Transactions</h3>
        <p style={{ paddingBottom: '30px' }}>
        If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred.
        We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
        </p>
        <h3 style={{ marginBottom: '30px' }} >Law enforcement</h3>
        <p style={{ paddingBottom: '30px' }}>
        Under certain circumstances, the Company may be required to disclose Your Personal Data
        if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
        </p>
        <h3 style={{ marginBottom: '30px' }} >Other legal requirements</h3>
        <p style={{ paddingBottom: '10px' }}>
        The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
        </p>

        <ul>
          <li style={{ marginBottom: '10px' }}>
          Comply with a legal obligation
          </li>
          <li style={{ marginBottom: '10px' }}>
          Protect and defend the rights or property of the Company
          </li>
          <li style={{ marginBottom: '10px' }}>
          Prevent or investigate possible wrongdoing in connection with the Service
          </li>
          <li style={{ marginBottom: '10px' }}>
          Protect the personal safety of Users of the Service or the public
          </li>
          <li style={{ marginBottom: '50px' }}>
          Protect against legal liability
          </li>
        </ul>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Security of Your Personal Data</h2>
        <p style={{ paddingBottom: '50px' }}>
        The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet,
        or method of electronic storage is 100% secure.
        While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Your California Privacy Rights (California's Shine the Light law)</h2>
        <p style={{ paddingBottom: '30px' }}>
        Under California Civil Code Section 1798 (California's Shine the Light law), California residents with an established business relationship
        with us can request information once a year about sharing their Personal Data with third parties for the third parties' direct marketing purposes.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        If you'd like to request more information under the California Shine the Light law, and if you are a California resident,
        You can contact Us using the contact information provided below.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >
            California Privacy Rights for Minor Users (California Business and Professions Code Section 22581)</h2>
        <p style={{ paddingBottom: '30px' }}>
        California Business and Professions Code section 22581 allow California residents under the age of 18 who are registered users of online sites,
        services or applications to request and obtain removal of content or information they have publicly posted.
        </p>
        <p style={{ paddingBottom: '30px' }}>
        To request removal of such data, and if you are a California resident, You can contact Us using the contact information provided below,
        and include the email address associated with Your account.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        Be aware that Your request does not guarantee complete or comprehensive removal of content or
        information posted online and that the law may not permit or require removal in certain circumstances.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >Links to Other Websites</h2>
        <p style={{ paddingBottom: '30px' }}>
        Our Service may contain links to other websites that are not operated by Us. If You click on a third party link,
        You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >
        Changes to this Privacy Policy</h2>
        <p style={{ paddingBottom: '30px' }}>
        We may update our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
        </p>
        <p style={{ paddingBottom: '30px' }}>
        We will let You know via email and/or a prominent notice on
        Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
        </p>
        <p style={{ paddingBottom: '50px' }}>
        You are advised to review this Privacy Policy periodically for any changes.
        Changes to this Privacy Policy are effective when they are posted on this page.
        </p>

        <h2 style={{ marginBottom: '30px', borderBottom: '1px solid #eaeaea' }} >
        Contact Us</h2>
        <p style={{ paddingBottom: '30px' }}>
        If you have any questions about this Privacy Policy, You can contact us:
        </p>
        <ul>
          <li style={{ marginBottom: '10px' }}>
          By email: Info@alioit.com
          </li>
        </ul>
      </Paper>
      </Container>
      </>
  );
};

export default PrivacyPolicy;
